export const AUTH_COOKIE = '_animatronauth';
export const ANON_USER_COOKIE = 'animatron:user:is-anon';
export const SECURE_TOKEN_HEADER_NAME = 'Animatron-Security-Token';
export const GUEST_ID_HEADER_NAME = 'Guest-ID';
export const ANM_LOCAL_STORAGE = 'animatron:state';
export const STREAM_LOCAL_STORAGE = 'animatron:stream:state';
